import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ToastrModule } from 'ngx-toastr';
import { FormsModule , ReactiveFormsModule} from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { SpinnerComponent } from './common/spinner/spinner.component';
import { GisComponent } from './components/geoportal/gis/gis.component';
import { SidebarComponent } from './components/geoportal/sidebar/sidebar.component';
import { AngularSplitModule } from 'angular-split';
import { NgxUiLoaderModule } from  'ngx-ui-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { InfoboxComponent } from './components/infobox/infobox.component';
import { ConstantsModule } from './common/constants/constants.module';
import { UtilsModule } from './common/utils/utils.module';
import { MapconstantsModule } from './components/geoportal/gis/mapconstants/mapconstants.module';
import { MisComponent } from './components/mis/mis.component';
import { BreadcrumbComponent } from './common/breadcrumb/breadcrumb.component';
import { LoginComponent } from './components/login/login.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SubmitdataComponent } from './components/submitdata/submitdata.component';
import { DatasubmitapprovalsComponent } from './components/submitdata/datasubmitapprovals/datasubmitapprovals.component';
import {ScrollDispatchModule} from "@angular/cdk/scrolling";
import { ExceldownloadComponent } from './components/submitdata/exceldownload/exceldownload.component';
import { ExceluploadComponent } from './components/submitdata/excelupload/excelupload.component';
import { ShapefileuploadComponent } from './components/submitdata/shapefileupload/shapefileupload.component';
import {TableConstantsModule} from './common/constants/tableconstants.module'
import { MisfilterComponent } from './common/misfilter/misfilter.component';
// import { HighchartsChartComponent } from 'highcharts-angular';
import { ChartsComponent } from './common/charts/charts.component';
import { ForminputComponent } from './components/submitdata/forminput/forminput.component';
import { SummaryComponent } from './components/submitdata/summary/summary.component';
import { PieChartComponent } from './common/charts/pie-chart/pie-chart.component';
import { BarChartComponent } from './common/charts/bar-chart/bar-chart.component';
import { BarBubbleChartComponent } from './common/charts/bar-bubble-chart/bar-bubble-chart.component';
import { EditWeightagesComponent } from './components/submitdata/edit-weightages/edit-weightages.component';
import { ApprovalsComponent } from './components/submitdata/approvals/approvals.component';
import { FloatwithMinmaxDirective } from './common/directives/floatwith-minmax.directive';
import { AdminpageComponent } from './components/submitdata/adminpage/adminpage.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ApprovalinfoComponent } from './common/ngbmodel/approvalinfo/approvalinfo.component';
import { KeysPipe } from './common/custompipes/keys.pipe';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DynamicindicatorComponent } from './components/submitdata/dynamicindicator/dynamicindicator.component';
import { BubbleChartComponent } from './common/charts/bubble-chart/bubble-chart/bubble-chart.component';
import { StackedBarChartComponent } from './common/charts/stacked-bar-chart/stacked-bar-chart/stacked-bar-chart.component';
import { UserManagementComponent } from './components/submitdata/user-management/user-management.component';
import { UserListComponent } from './components/submitdata/user-management/user-list/user-list.component';
import { AddUserComponent } from './components/submitdata/user-management/add-user/add-user.component';
import { LogoutPopupComponent } from './components/logout-popup/logout-popup.component';
import { UserInfoComponent } from './components/submitdata/user-management/user-info/user-info.component';
import { FilterPipe } from './components/submitdata/user-management/pipes/filter.pipe';
import { ShowErrorsComponent } from './components/submitdata/user-management/show-errors/show-errors/show-errors.component';
import { ChangePasswordComponent } from './components/submitdata/user-management/change-password/change-password.component';
import { ResetComponent } from './components/reset/reset.component';
import { CookieService } from 'ngx-cookie-service';
import { AlphabetsWithdotDirective } from './common/directives/alphabets-withdot.directive';
import { NotAllowSpacesDirective } from './common/directives/not-allow-spaces.directive';
import { AllowparanthesisonlyDirective } from './common/directives/allowparanthesisonly.directive';
import { NumbersonlyDirective } from './common/directives/numbersonly.directive';
import { TriggerComputationsComponent } from './components/submitdata/trigger-computations/trigger-computations.component';
import { DatePipe } from '@angular/common';
import { RequestExtensionComponent } from './components/submitdata/request-extension/request-extension.component';
import { CustomDatepickerComponent } from './common/custom-datepicker/custom-datepicker.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ExtensionApprovalComponent } from './components/submitdata/extension-approval/extension-approval.component';
import { ManualInterventionComponent } from './components/submitdata/manual-intervention/manual-intervention.component';
import { SetwindowComponent } from './common/ngbmodel/setwindow/setwindow.component';
import { EditComponent } from './common/ngbmodel/edit/edit.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ProfileLoginComponent } from './components/login/profile-login/profile-login.component';
import { ProfileFormComponent } from './components/login/profile-form/profile-form.component';
import { AggregationReportsComponent } from './components/submitdata/aggregation-reports/aggregation-reports.component';
import { AggregatedAdminReportsComponent } from './components/submitdata/aggregated-admin-reports/aggregated-admin-reports.component';
import { DownloadExcelComponent } from './components/submitdata/download-excel/download-excel.component';
import { UploadExcelComponent } from './components/submitdata/upload-excel/upload-excel.component';
import { RemoveRecordPopupComponent } from './components/submitdata/remove-record-popup/remove-record-popup.component';
import { EditWeightageComponent } from './components/submitdata/edit-weightage/edit-weightage.component';
import { DvmWeightageeditsComponent } from './dvm-weightageedits/dvm-weightageedits.component';
import { AlphabetsOnlyDirective } from './alphabets-only.directive';
import { DigitsOnlyDirective } from './digits-only.directive';
import { TwoDigitDecimalNumberDirective } from './common/directives/two-digit-decimal-number.directive';
import { MeetingModuleComponent } from './components/submitdata/meeting-module/meeting-module.component';
import { AdminmeetingModuleComponent } from './components/submitdata/adminmeeting-module/adminmeeting-module.component';
import { ViewmodalReportComponent } from './components/submitdata/viewmodal-report/viewmodal-report.component';
import { LandingModelComponent } from './common/ngbmodel/landing-model/landing-model.component';
// import { TwoDigitDecimalNumberComponent } from './common/directives/two-digit-decimal-number/two-digit-decimal-number.component';
import { DvmeditWeightageComponent } from './components/submitdata/dvmedit-weightage/dvmedit-weightage.component';
import { BlockcopyPasteDirective } from './common/directives/blockcopy-paste.directive';
import { CapsLockDirective } from './common/directives/caps-lock.directive';
import { RemovefilePopupComponent } from './common/ngbmodel/removefile-popup/removefile-popup.component';
import { StatemeetingReportsComponent } from './components/submitdata/statemeeting-reports/statemeeting-reports.component';
import { PopupsubmitDataComponent } from './components/submitdata/popupsubmit-data/popupsubmit-data.component';
import { MeetingreportStatusComponent } from './components/submitdata/meetingreport-status/meetingreport-status.component';
import { UploadconsolidateMeetingReportsComponent } from './components/submitdata/uploadconsolidate-meeting-reports/uploadconsolidate-meeting-reports.component';
import { PreviewfileUploadComponent } from './common/ngbmodel/previewfile-upload/previewfile-upload.component';
import { BroadcastingComponent } from './components/submitdata/broadcasting/broadcasting.component';
import { WhatsNewComponent } from './components/whats-new/whats-new.component';
import { MatPaginatorModule } from '@angular/material';
import { MandatoryThemesComponent } from './components/submitdata/mandatory-themes/mandatory-themes.component';
import { EditUserComponent } from './components/submitdata/user-management/edit-user/edit-user.component';
import { AdminListofDGCsComponent } from './components/submitdata/admin-listof-dgcs/admin-listof-dgcs.component';
import { StateListofDGCsComponent } from './components/submitdata/state-listof-dgcs/state-listof-dgcs.component';
import { DgcMeetingReportsComponent } from './components/submitdata/dgc-meeting-reports/dgc-meeting-reports.component';
import { AdminDgcreportsComponent } from './components/submitdata/admin-dgcreports/admin-dgcreports.component';
import { StateDgcreportsComponent } from './components/submitdata/state-dgcreports/state-dgcreports.component';
import { GdpmsdashboardComponent } from './components/gdpmsdashboard/gdpmsdashboard.component';
import { MeetingAttendanceReportComponent } from './components/submitdata/meeting-attendance-report/meeting-attendance-report.component';
// import { RejectwindowPopupComponent } from './components/submitdata/rejectwindow-popup/rejectwindow-popup.component';
// import { IndicatorrejectpopUpComponent } from './components/submitdata/indicatorrejectpop-up/indicatorrejectpop-up.component';
// import { ManualInterventionDataComponent } from './components/submitdata/manual-intervention-data/manual-intervention-data.component';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    SpinnerComponent,
    GisComponent,
    SidebarComponent,
    InfoboxComponent,
    MisComponent,
    BreadcrumbComponent,
    LoginComponent,
    SubmitdataComponent,
    DatasubmitapprovalsComponent,
    ExceldownloadComponent,
    ExceluploadComponent,
    ShapefileuploadComponent,
    MisfilterComponent,
    // HighchartsChartComponent,
    ChartsComponent,
    ForminputComponent,
    SummaryComponent,
    PieChartComponent,
    BarChartComponent,
    BarBubbleChartComponent,
    EditWeightagesComponent,
    ApprovalsComponent,
    FloatwithMinmaxDirective,
    AdminpageComponent,
    ApprovalinfoComponent,
    KeysPipe,
    DynamicindicatorComponent,
    BubbleChartComponent,
    StackedBarChartComponent,
    UserManagementComponent,
    UserListComponent,
    AddUserComponent,
    LogoutPopupComponent,
    UserInfoComponent,
    FilterPipe,
    ShowErrorsComponent,
    ChangePasswordComponent,
    ResetComponent,
    AlphabetsWithdotDirective,
    NotAllowSpacesDirective,
    AllowparanthesisonlyDirective,
    NumbersonlyDirective,
    TriggerComputationsComponent,
    RequestExtensionComponent,
    CustomDatepickerComponent,
    ExtensionApprovalComponent,
    ManualInterventionComponent,
    SetwindowComponent,
    EditComponent,
    ProfileLoginComponent,
    ProfileFormComponent,
    PopupsubmitDataComponent,
    AggregationReportsComponent,
    AggregatedAdminReportsComponent,
    DownloadExcelComponent,
    UploadExcelComponent,
    RemoveRecordPopupComponent,
    EditWeightageComponent,
    DvmWeightageeditsComponent,
    AlphabetsOnlyDirective,
    DigitsOnlyDirective,
    TwoDigitDecimalNumberDirective,
    MeetingModuleComponent,
    AdminmeetingModuleComponent,
    ViewmodalReportComponent,
    LandingModelComponent,
    // TwoDigitDecimalNumberComponent,
    DvmeditWeightageComponent,
    BlockcopyPasteDirective,
    CapsLockDirective,
    RemovefilePopupComponent,
    StatemeetingReportsComponent,
    PopupsubmitDataComponent,
    MeetingreportStatusComponent,
    UploadconsolidateMeetingReportsComponent,
    PreviewfileUploadComponent,
    BroadcastingComponent,
    WhatsNewComponent,
    MandatoryThemesComponent,
    EditUserComponent,
    AdminListofDGCsComponent,
    StateListofDGCsComponent,
    DgcMeetingReportsComponent,
    AdminDgcreportsComponent,
    StateDgcreportsComponent,
    GdpmsdashboardComponent,
    MeetingAttendanceReportComponent,
    // RejectwindowPopupComponent,
    // IndicatorrejectpopUpComponent,
    // ManualInterventionDataComponent
  ],
  entryComponents :[
    LoginComponent,
    ApprovalinfoComponent,
    AddUserComponent,
    LogoutPopupComponent,
    RemovefilePopupComponent,
    ChangePasswordComponent,
    SetwindowComponent,
    EditComponent,
    ProfileLoginComponent,  
    ProfileFormComponent,
    PopupsubmitDataComponent,
    RemoveRecordPopupComponent,
    ViewmodalReportComponent,
    LandingModelComponent,
    PreviewfileUploadComponent,
    EditUserComponent
    // RejectwindowPopupComponent,
    // IndicatorrejectpopUpComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AngularSplitModule.forRoot(),
    NgxUiLoaderModule,
    FormsModule,
    ReactiveFormsModule,
    ConstantsModule,
    MapconstantsModule,
    UtilsModule,
    HttpClientModule,
    ToastrModule.forRoot({timeOut: 3000, preventDuplicates: true, easing: 'ease-in', easeTime: 500}),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgbModule.forRoot(),
    ScrollDispatchModule,
    TableConstantsModule,
    NgMultiSelectDropDownModule,
    BsDatepickerModule.forRoot(),
    MatPaginatorModule
  ],
  providers: [CookieService,DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
